import { render, staticRenderFns } from "./WhatCanILearn.vue?vue&type=template&id=38d4d162&scoped=true&"
import script from "./WhatCanILearn.vue?vue&type=script&lang=ts&"
export * from "./WhatCanILearn.vue?vue&type=script&lang=ts&"
import style0 from "./WhatCanILearn.vue?vue&type=style&index=0&id=38d4d162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4d162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38d4d162', component.options)
    } else {
      api.reload('38d4d162', component.options)
    }
    module.hot.accept("./WhatCanILearn.vue?vue&type=template&id=38d4d162&scoped=true&", function () {
      api.rerender('38d4d162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/WhatCanILearn.vue"
export default component.exports